// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.UndoMarkPaymentAsPaidOfflineWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UndoMarkPaymentAsPaidOfflineWebApiRequestDto } from '../..';

export const UndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline_Path =
  '/api/web/v1/landlord/undoMarkPaymentAsPaidOffline';

/**
 * Undo a rent payment previously marked as received offline by the landlord
 */
export const UndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline = (
  postData: UndoMarkPaymentAsPaidOfflineWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UndoMarkPaymentAsPaidOfflineWebApiRequestDto, void>(
    {
      endpoint: UndoMarkPaymentAsPaidOfflineWebApiHandler_undoMarkPaymentAsPaidOffline_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
